import { z } from 'zod'

/** `計算区分`のスキーマ */
export const calculationTypeSchema = z.enum(['annualIncome', 'monthlyIncome'])

/** `計算区分`のモデル */
export type CalculationType = z.infer<typeof calculationTypeSchema>

/** `リーダー案件`のスキーマ */
export const leaderProjectSchema = z.enum(['inPlanning', 'notParticipating'])

/** `リーダー案件`のモデル */
export type LeaderProjectType = z.infer<typeof leaderProjectSchema>

/** `客先請求単価`のスキーマ */
export const clientBillingRateSchema = z
  .number()
  .min(55)
  .max(200)
  .refine((value) => value !== undefined)

/** `客先請求単価`のモデル */
export type ClientBillingRateType = z.infer<typeof clientBillingRateSchema>

/** `給与シミュレーションフォーム`のスキーマ */
export const salarySimulationFormSchema = z.object({
  calculationType: calculationTypeSchema,
  leaderProject: leaderProjectSchema,
  clientBillingRate: clientBillingRateSchema,
})

/** `客先請求単価`のモデル */
export type SalarySimulationFormType = z.infer<
  typeof salarySimulationFormSchema
>
